import React, { useState, useEffect, useRef } from "react";
import Counter from "./index";
import OrangeInfo from '../../assets/svgs/orange-info.svg';
import {PRODUCT_TYPES} from "../../components/contact-form/fields";

const DimensionImageTooltip = ({ children, dimension, productType }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [openedByClick, setOpenedByClick] = useState(false);

    const tooltipRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                if (openedByClick) {
                    setIsOpen(false);
                    setOpenedByClick(false);
                }
            }
        };

        if (isOpen && openedByClick) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, openedByClick]);


    const handleClick = () => {
        if (isOpen && !openedByClick) {
            setIsOpen(true)
            setOpenedByClick(true)
        } else {
            setIsOpen(false)
            setOpenedByClick(false)
        }
    };

    const handleMouseEnter = () => {
        if (!openedByClick) {
            setIsOpen(true);
        }
    };

    const handleMouseLeave = () => {
        if (!openedByClick) {
            setIsOpen(false);
        }
    };


    // const imageMapping = {
        // width: 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Car_Width.png?v=1756754819',
        // height: 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Car_Height.png?v=1756754819',
        // length: 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Car_Length.png?v=1756754819'
    // }
    const getImageMapping = (productType) => {
        const imageMappings = {
            [PRODUCT_TYPES.BOATS]: {
                width: 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Boat_width.png?v=1756905489',
                height: 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Boat_height.jpg?v=1756905489',
                length: 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Boat_length.png?v=1756905489'
            },
            // Default fallback to car images if productType is not recognized
            default: {
                width: 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Car_Width.png?v=1756754819',
                height: 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Car_Height.png?v=1756754819',
                length: 'https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Car_Length.png?v=1756754819'
            }
        };

        return imageMappings[productType] || imageMappings.default;
    };

    const imageMapping = getImageMapping(productType);

    return (
        <div className="dimension-image-tooltip">
            {children}
            <div className="dimension-image-tooltip__trigger">
                <img src={OrangeInfo}
                    alt="Info Icon"
                    onClick={handleClick}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    className="dimension-image-tooltip__trigger-icon"
                />

                {isOpen && (
                    <div className="dimension-image-tooltip__content" ref={tooltipRef}>
                        <img src={imageMapping[dimension]} alt={dimension} />
                    </div>
                )}
            </div>
        </div>
    )
}

const SizingCounters = ({ label, onChange, value = { width: 0, height: 0, length: 0 }, productType }) => {

    const [wasFilled, setWasFilled] = useState(false);

    useEffect(() => {
        if (value.width > 0 || value.height > 0 || value.length > 0) {
            setWasFilled(true);
        }
    }, [value]);

    const handleInputChange = (dimension, inputValue) => {
        const newValue = {
            ...value,
            [dimension]: inputValue
        };
        onChange(newValue);
    };
    const dimensions = [
        { key: 'width', label: 'Width' },
        { key: 'height', label: 'Height' },
        { key: 'length', label: 'Length' }
    ];

    const wrapperClasses = [
        "sizing-counters",
        wasFilled ? "sizing-counters--filled" : ""
    ]

    return (
        <div className={wrapperClasses.join(' ')}>
            {dimensions.map((dimension) => (
                <div key={dimension.key} className="sizing-counters__counter">
                    <DimensionImageTooltip productType={productType} dimension={dimension.key}>
                        <p className="sizing-counters__counter-label">{dimension.label}</p>
                    </DimensionImageTooltip>
                    <Counter count={value[dimension.key]} onChange={newValue => handleInputChange(dimension.key, newValue)} />
                </div>
            ))}
            <div />
        </div>
    )
}

export default SizingCounters;
